/// <reference types="vite-plugin-svgr/client" />
import LycaMobile from "@monorepo/assets/src/svg/icons/gsmVoucher/Lyca_Mobile.svg?react";
import Orange from "@monorepo/assets/src/svg/icons/gsmVoucher/Orange.svg?react";
import Play from "@monorepo/assets/src/svg/icons/gsmVoucher/Play.svg?react";
import PlusMobile from "@monorepo/assets/src/svg/icons/gsmVoucher/Plus_Mobile.svg?react";
import TMobile from "@monorepo/assets/src/svg/icons/gsmVoucher/T-Mobile.svg?react";
import Telegrosik from "@monorepo/assets/src/svg/icons/gsmVoucher/Telegrosik.svg?react";
import { VoucherProvidersEnum } from "@monorepo/types";

export const GsmVoucherVendorIcon: React.FC<{ vendor: VoucherProvidersEnum }> = ({ vendor }) => {
  const getGsmVoucherVendorIconByLabel = (key: VoucherProvidersEnum) => {
    switch (key) {
      case VoucherProvidersEnum.LYCA_MOBILE:
        return <LycaMobile style={{ height: "40px", width: "100px" }} />;
      case VoucherProvidersEnum.ORANGE:
        return <Orange style={{ height: "40px", width: "100px" }} />;
      case VoucherProvidersEnum.PLAY:
        return <Play style={{ height: "40px", width: "100px" }} />;
      case VoucherProvidersEnum.POLKOMTEL_PLUS:
        return <PlusMobile style={{ height: "40px", width: "100px" }} />;
      case VoucherProvidersEnum.T_MOBILE:
        return <TMobile style={{ height: "40px", width: "100px" }} />;
      case VoucherProvidersEnum.TELEGROSIK:
        return <Telegrosik style={{ height: "40px", width: "100px" }} />;
    }
  };

  return <>{getGsmVoucherVendorIconByLabel(vendor)}</>;
};
